<script setup lang="ts">
defineProps({
	title: {
		type: String,
		required: true,
	},
	buttonText: {
		type: String,
		required: true,
	},
})

const emit = defineEmits(['translate'])

function toggleLocalLanguage() {
	emit('translate')
}
</script>

<template>
	<div class="my-32px mdp:mb-casual-friends mdp:mt-0">
		<section
			class="typography-s2-reg my-32px flex flex-wrap items-center justify-between gap-4px rounded-lg bg-n-50 p-16px text-n-950 mdp:px-20px"
		>
			<p>
				{{ title }}
			</p>
			<p
				class="cursor-pointer select-none underline mdp:font-medium lg:hover:text-o-500"
				@click="toggleLocalLanguage"
			>
				{{ buttonText }}
			</p>
		</section>
	</div>
</template>
